import React from 'react';
import { BrowserRouter as Router, NavLink, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import Modal from 'react-modal';
import { WagmiConfig } from 'wagmi';

import { configureStore } from 'store/configureStore';
import { configureWagmi } from 'wagmi/configureWagmi';

import { BrowseArtworks } from 'apps/browse/components/BrowseArtworks';
import { BrowseArtists } from 'apps/browse/components/BrowseArtists';
import { VaultContainer } from 'vault/VaultContainer';
import { ArtworkDetail } from 'artworks/ArtworkDetail';
import { ErrorModalContainer } from 'modals/ErrorModalContainer';

import { ModalPlaylistPlayerContainer } from 'player/ModalPlaylistPlayerContainer';
import { QueryStringToState } from 'player/QueryStringToState';

import { UserProvider } from 'hooks/useCurrentUser';

import { MenuItemPortal } from './MenuItemPortal';
import { ChromecastProvider } from 'context/ChromecastContext';
import { CollectionDetail } from 'collection/CollectionDetail';

Modal.defaultStyles = {}; // Prevent rendering of styles, we'll style with CSS.

const store = configureStore();
const wagmiClient = configureWagmi();

export type AppDispatch = typeof store.dispatch;

// Note: Is this React routing duplicated since routing is already done in ruby?

export const App = () => (
  <Router>
    <Provider store={store}>
      <UserProvider>
        <ChromecastProvider>
          <WagmiConfig client={wagmiClient}>
            <div className='layout--responsive h-100'>
              <div className='container h-100'>
                <Switch>
                  <Route path={Routes.vault_path()} component={VaultContainer} />
                  <Route path={Routes.artworks_path()} component={BrowseArtworks} />
                  <Route path={Routes.artists_path()} component={BrowseArtists} />
                  <Route
                    exact
                    path={Routes.artist_artwork_path(':artistSlug', ':artworkSlug')}
                    render={({ match }) => <ArtworkDetail artworkSlug={match.params.artworkSlug} />}
                  />
                  <Route
                    exact
                    path={Routes.artist_collection_path(':artistSlug', ':collectionSlug')}
                    render={({ match }) => (
                      <CollectionDetail
                        artistSlug={match.params.artistSlug}
                        collectionSlug={match.params.collectionSlug}
                      />
                    )}
                  />
                </Switch>
                {/*  TODO: potential code for making navbar a react component. Overrides the existing navlinks for artworks and artists */}
                <MenuItemPortal portalIndex={0}>
                  <NavLink
                    to={Routes.artworks_path()}
                    activeClassName='selected'
                    className='navigation-menu__link'
                  >
                    Artworks
                  </NavLink>
                </MenuItemPortal>
                <MenuItemPortal portalIndex={1}>
                  <NavLink
                    to={Routes.artists_path()}
                    activeClassName='selected'
                    className='navigation-menu__link'
                  >
                    Artists
                  </NavLink>
                </MenuItemPortal>
                <QueryStringToState />
                <ModalPlaylistPlayerContainer />
                <ErrorModalContainer />
              </div>
            </div>
          </WagmiConfig>
        </ChromecastProvider>
      </UserProvider>
    </Provider>
  </Router>
);
